import { gql } from "graphql-request";

export const GET_VISIBILITY_DUTY_SAVING_UTILIZED = gql`
  query DashboardVisibilityDutySavingsUtilized(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityDutySavingsUtilized(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        year
        month
        totalDutySavings
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_MANUFACTURERS = gql`
  query DashboardVisibilityGetManufacturers(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityGetManufacturers(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        manufacturer
        manufacturerName
        tariffValue
        tariffDuty
        customValue
        lineCount
        entryCount
        htsCodeCount
        country
        lastEntryDate
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_MANUFACTURER_HTS_BREAKDOWN = gql`
  query DashboardVisibilityManufacturerHtsBreakdown(
    $input: ManufacturerHtsBreakdownInput
  ) {
    dashboardVisibilityManufacturerHtsBreakdown(input: $input) {
      data {
        htsCode
        lineCount
        totalValue
        totalDuty
        lastEntryDate
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_OVERALL_IMPORTS = gql`
  query DashboardVisibilityOverallImportValue(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityOverallImportValue(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        month
        totalGoodsValue
        totalDuties
        year
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_METRICS = gql`
  query DashboardVisibilityImportMetrics(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityImportMetrics(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        distinctHts
        distinctImports
        entryLines
        totalDutySaving
        customsDuty
        customsValue
        distinctSuppliers
        avgShipmentValue
        effectiveDutyRates
        aceRange {
          minDate
          maxDate
        }
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_FILTER_OPTIONS = gql`
  query DashboardVisibilityFilterOptions(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityFilterOptions(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        brokerOptions
        iorOptions
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_TARIFF_HTS = gql`
  query DashboardVisibilityLineTariffValueByHts(
    $dashboardVisibility: DashboardLineTariffValueByHtsInput
  ) {
    dashboardVisibilityLineTariffValueByHts(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        htsNumber
        tariffDuty
        tariffValue
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_DUTY_SPEND = gql`
  query DashboardVisibilityDutySpend(
    $dashboardVisibility: DashboardDutySpendInput
  ) {
    dashboardVisibilityDutySpend(dashboardVisibility: $dashboardVisibility) {
      data {
        dutySum
        totalMfnDuty
        totalMtbDuty
        total201Duty
        total232Duty
        total301Duty
        totalDutiesPaid
        totalOtherDuties
        totalExclusionsSaving
        totalDutySaving
        totalLineTariffGoodValueAmount
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_IMPORT_EXPORT = gql`
  query DashboardVisibilityImportToExportTable(
    $dashboardVisibility: ImportToExportInput
  ) {
    dashboardVisibilityImportToExportTable(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        exports {
          _id
          htsNumbers {
            id
            avgShipmentValue
            customDuty
            customValue
            distinctImports
            distinctImportsValues
            distinctSuppliers
            distinctSuppliersValues
            effectiveDutyRate
            entrySummaryCount
            dutySaved
          }
        }
        _id
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_DUTY_ANALYTICS_BY_AUTHORITY = gql`
  query DutyAnalyticsByAuthority($input: DutyAnalyticsByAuthorityInput) {
    dutyAnalyticsByAuthority(input: $input) {
      data {
        grandTotal
        usedLegacyFallback
        hasLiquidationData
        authorities {
          authority
          totalDuty
          entryCount
          codes {
            code
            columnName
            totalDuty
            entryCount
          }
        }
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_IEEPA_REFUND_BY_LIQUIDATION = gql`
  query IeepaRefundByLiquidation($input: IeepaRefundByLiquidationInput) {
    ieepaRefundByLiquidation(input: $input) {
      data {
        ieepaGrandTotal
        hasLiquidationData
        breakdown {
          authority
          liquidationStatus
          totalDuty
          entryCount
        }
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_CAPE_REFUND_SUMMARY = gql`
  query CapeRefundSummary($input: CapeRefundSummaryInput) {
    capeRefundSummary(input: $input) {
      data {
        capeCertifiedAmount
        capeCertifiedEntries
        capePendingAmount
        capePendingEntries
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_AVERAGE_UNIT_COST = gql`
  query GetAverageUnitCost($input: AverageUnitCostInput) {
    getAverageUnitCost(input: $input) {
      data {
        averageUnitCost
        totalGoodsValue
        totalQuantity
        recordCount
        origins
        dateRange {
          minDate
          maxDate
        }
        availableOriginCodes
        availableManufacturers {
          manufacturerID
          manufacturerName
          value
        }
        chartData {
          year
          month
          averageUnitCost
          totalGoodsValue
          totalQuantity
        }
        plotData {
          date
          unitCost
          quantity
          value
          countryOfOriginCode
          manufacturerID
          htsNumberFull
          entrySummaryNumber
          entryLine
          lineTariffDutyAmount
          mfnDuty
          duty301
          duty232
          oth99Duties
        }
      }
      meta {
        countDocs
      }
    }
  }
`;
